import { configureStore } from "@reduxjs/toolkit";
import settingsReducer from "../reducers/settingsReducer";
import loadingReducer from "../reducers/loadingReducer";
import messageReducer from "../reducers/messageReducer";
import appReducer from "../reducers/appReducer";

const store = configureStore({
  reducer: {
    settings: settingsReducer,
    loading: loadingReducer,
    message: messageReducer,
    app: appReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
